import { render, staticRenderFns } from "./ResubmitInterstate.vue?vue&type=template&id=15792326&scoped=true"
import script from "./ResubmitInterstate.vue?vue&type=script&lang=js"
export * from "./ResubmitInterstate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15792326",
  null
  
)

export default component.exports